import { rgba } from 'polished';
import {
  sideNavBaseStyle,
  TSideNavTheme,
} from '../../base/customComponents/sideNav';
import beachBackground from '../../../assets/puntcity/images/backgrounds/beach-bg.png';

import { TStyleConfig } from '../../base/types';

export const SideNav: TStyleConfig<TSideNavTheme> = {
  baseStyle: (props) => {
    const base = sideNavBaseStyle(props);

    return {
      ...base,
      readableColor: 'white',
      borderBottom: 'white',
      bottomBorderRadius: base.borderBottomRadius,
      background: {
        bgImage: [`url(${beachBackground})`, null, null, 'transparent'],
        bg: 'transparent',
        bgSize: 'cover',
        bgRepeat: 'no-repeat',
        boxShadow: 'lg',
        borderRadius: [null, null, null, 'md'],
        alignSelf: [null, null, null, 'flex-start'],
        overflow: 'hidden',
        w: 'auto',
        m: [null, null, null, '5px 0px'],
        mb: [null, null, null, '9px'],
      },
      drawer: {
        ...base.drawer,
      },
      drawerBody: {
        '> div, a': {
          ml: ['0', null, '2'],

          '> .dropDownInner, a[class*="dropDownInner"]': {
            _first: {
              borderColor: 'transparent',
              cursor: 'initial',
            },
            '&:hover, &:active': {
              bg: rgba(`${props.theme.colors.beta[500]}`, 0.8),
            },
          },
        },
      },
      icon: {
        ...base.icon,
        boxSize: '5',
        color: 'white',
        fill: 'white',
      },
      headerSX: {
        cursor: 'default',
        fill: 'white',
        height: '45px',
        borderColor: 'transparent',
        '&:hover': {
          borderColor: 'transparent',
          bg: 'transparent',
        },
      },
      dropDownInner: {
        ...base.dropDownInner,
        color: 'white',
        px: '4',
      },
      linkSX: {
        ...base.linkSX,
      },
      link: {
        ...base.link,

        fontSize: 'sm',
        fontWeight: 'normal',
        fontStyle: 'normal',
        height: '55px',
        color: 'white',
        transition: 'all, 0.2s linear',
        borderLeftWidth: '3px',
        borderLeftColor: 'transparent',
        fontFamily: 'Montserrat',
        textTransform: 'uppercase',
        boxShadow: '0px 1px 0px 0px rgba(61, 59, 211, 0.40)',

        borderBottomWidth: '1px',
        borderBottomColor: ['transparent', null, null, 'blackAlpha.500'],

        p: '4',
        ml: '0',
        '~ .nested': {
          pl: '10',
        },

        ':hover': {
          borderBottomColor: 'transparent',
          bg: 'blackAlpha.500',
          height: '55px',
        },

        ':active': {
          borderBottomColor: 'transparent',
          bg: 'alpha.500',
        },

        '> .icon, .svgIcon, .dropDownIcon': {
          transition: 'all, 0.2s linear',
        },

        '.dropDownIcon': {
          fill: 'none',
        },
      },

      dropDownContainerClosed: {
        '> a, .dropDownIcon, a': {
          color: 'white',
        },

        '&:hover, &:active': {
          color: 'white',

          '.dropDownInner': {
            ...base.dropDownInner,
            color: 'white',
            height: '55px',
            px: '4',
          },

          '.svgIcon, .icon': {
            color: 'white',
          },
        },
      },
      dropDownContainerOpen: {
        ...base.dropDownContainerOpen,

        height: '55px',
        p: '0',
        color: 'white',

        _hover: {
          '.dropDownInner': {
            bg: 'alpha.800',
            color: 'white',
          },
        },

        '.dropDownInner': {
          bg: 'alpha.800',
          color: 'white',
        },

        '> a, .dropDownIcon, a': {
          color: 'white',
        },

        '> .icon, .svgIcon, .dropDownIcon': {
          color: 'white',
        },
      },
    };
  },
  sizes: {},
  variants: {},
};
